export enum EChartIndicator {
  TI_MA = 'TI_MA',
  TI_SD = 'TI_SD',
  TI_SO = 'TI_SO',
  TI_ATR = 'TI_ATR',
  TI_SAR = 'TI_SAR',
  TI_CCI = 'TI_CCI',
  TI_RSI = 'TI_RSI',
  TI_BOLL = 'TI_BOLL',
  TI_MACD = 'TI_MACD',
  TI_EMA = 'TI_EMA',
  TI_WMA = 'TI_WMA'
}

export const chartMainIndicators = [
  EChartIndicator.TI_MA,
  EChartIndicator.TI_SAR,
  EChartIndicator.TI_BOLL,
  EChartIndicator.TI_EMA,
  EChartIndicator.TI_WMA
];

export const chartSubIndicators = [
  EChartIndicator.TI_MACD,
  EChartIndicator.TI_CCI,
  EChartIndicator.TI_RSI,
  EChartIndicator.TI_SD,
  EChartIndicator.TI_SO,
  EChartIndicator.TI_ATR
];

export const chartMainAndSubIndicators = [...chartMainIndicators, ...chartSubIndicators];

export const mapChartIndicatorTitle: Record<EChartIndicator, string> = {
  [EChartIndicator.TI_MA]: 'MA',
  [EChartIndicator.TI_SAR]: 'SAR',
  [EChartIndicator.TI_BOLL]: 'BOLL',
  [EChartIndicator.TI_EMA]: 'EMA',
  [EChartIndicator.TI_WMA]: 'WMA',
  [EChartIndicator.TI_MACD]: 'MACD',
  [EChartIndicator.TI_CCI]: 'CCI',
  [EChartIndicator.TI_RSI]: 'RSI',
  [EChartIndicator.TI_SD]: 'SD',
  [EChartIndicator.TI_SO]: 'SO',
  [EChartIndicator.TI_ATR]: 'ATR'
};
